export default __webpack_public_path__ + "static/media/320px-Bandera_de_Navarra.svg.6c1b566b.png";